import React, { useEffect } from "react";
import { gsap } from "gsap";
import "../CaseResult/Result-p.css";

const Resultp = () => {
  useEffect(() => {
    // GSAP Animation
    const image = document.querySelector(".entry-image-ep");
    const overlay = document.querySelector(".entry-overlay-ep");
    const text = document.querySelector(".entry-text-ep");
    const verticalStrips = document.querySelectorAll(".vertical-strip-ep");

    gsap.fromTo(
      ".vertical-strip-ep",
      {
        scaleX: 0,
        opacity: 0,
        x: "-100%",
      },
      {
        duration: 2,
        scaleX: 1,
        opacity: 1,
        x: "0%",
        stagger: 0.05,
        ease: "power3.out",
        onComplete: () => {
          // Fade in the overlay text and main text
          gsap.to(overlay, { opacity: 1, duration: 1 });
          gsap.to(text, { opacity: 1, duration: 1 });

          // Fade out the strips after animation
          gsap.to(verticalStrips, { opacity: 0, duration: 1, stagger: 0.05 });
        },
      },
    );
  }, []);

  return (
    <div className="entry-container-ep">
      <div className="entry-image-container-ep">
        <img src="/cased.webp" alt="Entry" className="entry-image-ep" />
        <div className="entry-overlay-ep">
          <h1 className="entry-overlay-text-ep">Detailed Results</h1>
          <p className="entry-text-ep">
            We aim to lead in each practice and area of law we work in. Feel
            free to check our case results.
          </p>
        </div>
      </div>
      <div className="strips-ep">
        {[...Array(25)].map((_, index) => (
          <div key={index} className="vertical-strip-ep"></div>
        ))}
      </div>
    </div>
  );
};

export default Resultp;
